var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.formValid,
            callback: function($$v) {
              _vm.formValid = $$v
            },
            expression: "formValid"
          }
        },
        [
          _c(
            "v-tabs",
            {
              staticClass: "sub-menu md-3",
              attrs: { "slider-color": "primary" }
            },
            [
              _c("v-tab", { key: "general", staticClass: "sub-menu-item" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("settings.systemSettings.menu.general")) +
                    " "
                )
              ]),
              _c(
                "v-tab",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.$store.getters["userProperties"].system_settings
                          .is_module_delegation_enabled === 2,
                      expression:
                        "$store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2"
                    }
                  ],
                  key: "delegation-order",
                  staticClass: "sub-menu-item",
                  attrs: { disabled: _vm.settings.delegation_order_type === 1 }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("settings.systemSettings.menu.delegationOrder")
                      ) +
                      " "
                  )
                ]
              ),
              _c(
                "v-tab",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.$store.getters["userProperties"].system_settings
                          .is_module_delegation_enabled === 2 ||
                        _vm.$store.getters["userProperties"].system_settings
                          .is_module_travel_service_enabled === 2,
                      expression:
                        "\n          $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2 ||\n            $store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2\n        "
                    }
                  ],
                  key: "API",
                  staticClass: "sub-menu-item"
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("settings.systemSettings.menu.api")) +
                      " "
                  )
                ]
              ),
              _c("v-tab", { key: "IP", staticClass: "sub-menu-item" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("settings.systemSettings.menu.ip")) + " "
                )
              ]),
              _c(
                "v-tab-item",
                { key: "general", staticClass: "mt-2" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.delegationEmailTypes,
                      label: _vm.$t(
                        "settings.systemSettings.emailNotificationSetting"
                      )
                    },
                    model: {
                      value: _vm.settings.delegation_emails,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "delegation_emails", $$v)
                      },
                      expression: "settings.delegation_emails"
                    }
                  }),
                  _vm.$store.getters["userProperties"].system_settings
                    .is_module_delegation_enabled === 2
                    ? _c("v-select", {
                        attrs: {
                          items: _vm.delegationOrderRequiredOption,
                          label: _vm.$t(
                            "settings.systemSettings.isDelegationOrderRequired"
                          )
                        },
                        model: {
                          value: _vm.settings.delegation_order_type,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "delegation_order_type", $$v)
                          },
                          expression: "settings.delegation_order_type"
                        }
                      })
                    : _vm._e(),
                  _c("v-select", {
                    attrs: {
                      items: _vm.translationModifications,
                      label: _vm.$t(
                        "settings.systemSettings.translationModification"
                      )
                    },
                    model: {
                      value: _vm.settings.translations_modifications,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.settings,
                          "translations_modifications",
                          $$v
                        )
                      },
                      expression: "settings.translations_modifications"
                    }
                  }),
                  _c(
                    "fieldset",
                    { staticClass: "custom-fieldset" },
                    [
                      _c("legend", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("settings.systemSettings.safeLevelSettings")
                          )
                        )
                      ]),
                      _c("v-select", {
                        attrs: {
                          items: _vm.passwordExpire,
                          label: _vm.$t(
                            "settings.systemSettings.passwordStandardExpireAt"
                          )
                        },
                        model: {
                          value: _vm.settings.password_expiration,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "password_expiration", $$v)
                          },
                          expression: "settings.password_expiration"
                        }
                      }),
                      _c("amount-input", {
                        attrs: {
                          label: _vm.$t(
                            "settings.systemSettings.blockAfterFailedTry"
                          ),
                          rules: [
                            function(v) {
                              return v > 0 || _vm.$t("global.valueNotAllowed")
                            }
                          ],
                          model: _vm.settings.block_after_failed_try
                        },
                        on: {
                          "update:model": function($event) {
                            return _vm.$set(
                              _vm.settings,
                              "block_after_failed_try",
                              $event
                            )
                          }
                        }
                      }),
                      _c("amount-input", {
                        attrs: {
                          label: _vm.$t(
                            "settings.systemSettings.blockAfterFailedTryTime"
                          ),
                          rules: [
                            function(v) {
                              return v > 0 || _vm.$t("global.valueNotAllowed")
                            }
                          ],
                          model: _vm.settings.block_after_failed_try_time
                        },
                        on: {
                          "update:model": function($event) {
                            return _vm.$set(
                              _vm.settings,
                              "block_after_failed_try_time",
                              $event
                            )
                          }
                        }
                      }),
                      _c("amount-input", {
                        attrs: {
                          label: _vm.$t("settings.systemSettings.sessionTime"),
                          rules: [
                            function(v) {
                              return v > 0 || _vm.$t("global.valueNotAllowed")
                            },
                            function(v) {
                              return v >= 5 || _vm.$t("minimum 5")
                            }
                          ],
                          model: _vm.settings.session_time
                        },
                        on: {
                          "update:model": function($event) {
                            return _vm.$set(
                              _vm.settings,
                              "session_time",
                              $event
                            )
                          }
                        }
                      }),
                      _c(
                        "fieldset",
                        { staticClass: "custom-fieldset" },
                        [
                          _c("legend", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "settings.systemSettings.passwordRequirements"
                                )
                              )
                            )
                          ]),
                          _c("amount-input", {
                            attrs: {
                              label: _vm.$t(
                                "settings.systemSettings.minimumPasswordLength"
                              ),
                              rules: [
                                function(v) {
                                  return (
                                    v > 0 || _vm.$t("global.valueNotAllowed")
                                  )
                                }
                              ],
                              model: _vm.settings.minimum_password_length
                            },
                            on: {
                              "update:model": function($event) {
                                return _vm.$set(
                                  _vm.settings,
                                  "minimum_password_length",
                                  $event
                                )
                              }
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.enableDisable,
                              label: _vm.$t(
                                "settings.systemSettings.lowerLettersRequiredInPassword"
                              )
                            },
                            model: {
                              value:
                                _vm.settings.lower_letters_required_in_password,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "lower_letters_required_in_password",
                                  $$v
                                )
                              },
                              expression:
                                "settings.lower_letters_required_in_password"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.enableDisable,
                              label: _vm.$t(
                                "settings.systemSettings.upperLettersRequiredInPassword"
                              )
                            },
                            model: {
                              value:
                                _vm.settings.upper_letters_required_in_password,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "upper_letters_required_in_password",
                                  $$v
                                )
                              },
                              expression:
                                "settings.upper_letters_required_in_password"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.enableDisable,
                              label: _vm.$t(
                                "settings.systemSettings.digitsRequiredInPassword"
                              )
                            },
                            model: {
                              value: _vm.settings.digits_required_in_password,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "digits_required_in_password",
                                  $$v
                                )
                              },
                              expression: "settings.digits_required_in_password"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.enableDisable,
                              label: _vm.$t(
                                "settings.systemSettings.specialCharactersRequiredInPassword"
                              )
                            },
                            model: {
                              value:
                                _vm.settings
                                  .special_characters_required_in_password,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "special_characters_required_in_password",
                                  $$v
                                )
                              },
                              expression:
                                "settings.special_characters_required_in_password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.$store.getters["userProperties"].system_settings
                    .is_module_delegation_enabled === 2
                    ? _c(
                        "fieldset",
                        { staticClass: "custom-fieldset" },
                        [
                          _c("legend", [
                            _vm._v(
                              _vm._s(_vm.$t("settings.systemSettings.reports"))
                            )
                          ]),
                          _c("ajax-single-file", {
                            attrs: {
                              items: _vm.fileReportItems,
                              model: _vm.headerReportImageFileId,
                              label: _vm.$t(
                                "settings.systemSettings.documentReportHeaderImage"
                              ),
                              "max-file-size-k-b": 128
                            },
                            on: {
                              "update:model": function($event) {
                                _vm.headerReportImageFileId = $event
                              }
                            }
                          }),
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.reportTypeNames,
                              label: _vm.$t(
                                "settings.systemSettings.allowedReportTypes"
                              ),
                              clearable: "",
                              multiple: ""
                            },
                            model: {
                              value: _vm.settings.allowed_report_types,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "allowed_report_types",
                                  $$v
                                )
                              },
                              expression: "settings.allowed_report_types"
                            }
                          }),
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.reportFileFormats,
                              label: _vm.$t(
                                "settings.systemSettings.allowedReportFileTypes"
                              ),
                              clearable: "",
                              multiple: ""
                            },
                            model: {
                              value: _vm.settings.allowed_report_file_formats,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "allowed_report_file_formats",
                                  $$v
                                )
                              },
                              expression: "settings.allowed_report_file_formats"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$store.getters["userProperties"].system_settings
                    .is_module_delegation_enabled === 2
                    ? _c(
                        "fieldset",
                        { staticClass: "custom-fieldset" },
                        [
                          _c("legend", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("settings.systemSettings.documentsView")
                              )
                            )
                          ]),
                          _c("ajax-single-file", {
                            attrs: {
                              items: _vm.fileItems,
                              model: _vm.headerImageFileId,
                              label: _vm.$t(
                                "settings.systemSettings.documentHeaderImage"
                              ),
                              "max-file-size-k-b": 128
                            },
                            on: {
                              "update:model": function($event) {
                                _vm.headerImageFileId = $event
                              }
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.enableDisable,
                              label: _vm.$t(
                                "settings.systemSettings.pdfAttachmentOnly"
                              )
                            },
                            model: {
                              value: _vm.settings.pdf_attachment_only,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "pdf_attachment_only",
                                  $$v
                                )
                              },
                              expression: "settings.pdf_attachment_only"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.delegationDocumentViewTypes,
                              label: _vm.$t(
                                "settings.systemSettings.settlementDocumentTemplate"
                              )
                            },
                            model: {
                              value:
                                _vm.settings
                                  .delegation_settlement_document_view,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "delegation_settlement_document_view",
                                  $$v
                                )
                              },
                              expression:
                                "settings.delegation_settlement_document_view"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.enableDisable,
                              label: _vm.$t(
                                "settings.systemSettings.mileageForNonPrivateVehicles"
                              )
                            },
                            model: {
                              value:
                                _vm.settings.mileage_for_non_private_vehicles,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "mileage_for_non_private_vehicles",
                                  $$v
                                )
                              },
                              expression:
                                "settings.mileage_for_non_private_vehicles"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.enableDisable,
                              label: _vm.$t(
                                "settings.systemSettings.delegationSettlementDocumentCopyDelegationOrder"
                              )
                            },
                            model: {
                              value:
                                _vm.settings
                                  .delegation_settlement_document_copy_delegation_order,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "delegation_settlement_document_copy_delegation_order",
                                  $$v
                                )
                              },
                              expression:
                                "settings.delegation_settlement_document_copy_delegation_order"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.documentLanguage,
                              label: _vm.$t(
                                "settings.systemSettings.documentLanguage"
                              )
                            },
                            model: {
                              value: _vm.settings.document_language,
                              callback: function($$v) {
                                _vm.$set(_vm.settings, "document_language", $$v)
                              },
                              expression: "settings.document_language"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$store.getters["userProperties"].system_settings
                    .is_module_delegation_enabled === 2
                    ? _c(
                        "fieldset",
                        { staticClass: "custom-fieldset" },
                        [
                          _c("legend", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "settings.systemSettings.documentNumbers"
                                )
                              )
                            )
                          ]),
                          _vm.settings.delegation_order_type === 3
                            ? _c("v-checkbox", {
                                attrs: {
                                  label: _vm.$t(
                                    "settings.systemSettings.synchroDelegationSettlementAndDelegationOrderNumber"
                                  ),
                                  "true-value": 2,
                                  "false-value": 1
                                },
                                model: {
                                  value: _vm.settings.is_synchro_numbers,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "is_synchro_numbers",
                                      $$v
                                    )
                                  },
                                  expression: "settings.is_synchro_numbers"
                                }
                              })
                            : _vm._e(),
                          _c("v-select", {
                            attrs: {
                              items: _vm.delegationNumberSettingType,
                              label: _vm.$t(
                                "settings.systemSettings.delegationNumberSettingType"
                              )
                            },
                            on: {
                              change: function(value) {
                                _vm.changeAfterConfirm(
                                  value,
                                  _vm.settings,
                                  "delegation_number_setting_type"
                                )
                              }
                            },
                            model: {
                              value: _vm.contextDelegationNumberSettingType,
                              callback: function($$v) {
                                _vm.contextDelegationNumberSettingType = $$v
                              },
                              expression: "contextDelegationNumberSettingType"
                            }
                          }),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-select",
                                          _vm._g(
                                            {
                                              attrs: {
                                                items: _vm.delegationNumberDate,
                                                label: _vm.$t(
                                                  "settings.systemSettings.delegationNumberDate"
                                                )
                                              },
                                              on: {
                                                change: function(value) {
                                                  _vm.changeAfterConfirm(
                                                    value,
                                                    _vm.settings,
                                                    "delegation_number_date"
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.contextDelegationNumberDate,
                                                callback: function($$v) {
                                                  _vm.contextDelegationNumberDate = $$v
                                                },
                                                expression:
                                                  "contextDelegationNumberDate"
                                              }
                                            },
                                            on
                                          )
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3201849343
                              )
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "settings.systemSettings.changeThisSettingCanBlock"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "v-select",
                            {
                              attrs: {
                                items: _vm.availableDelegationNumberTemplates,
                                label: _vm.$t(
                                  "settings.systemSettings.delegationNumberTemplate"
                                ),
                                rules: _vm.settings.validateTemplateMask()
                              },
                              on: {
                                change: function(value) {
                                  _vm.changeAfterConfirm(
                                    value,
                                    _vm.settings,
                                    "delegation_number_template"
                                  )
                                }
                              },
                              model: {
                                value: _vm.contextDelegationNumberTemplate,
                                callback: function($$v) {
                                  _vm.contextDelegationNumberTemplate = $$v
                                },
                                expression: "contextDelegationNumberTemplate"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    top: "-13px"
                                  },
                                  attrs: { slot: "append-outer" },
                                  slot: "append-outer"
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        block: "",
                                        color: "accent",
                                        to:
                                          "/settings/system-settings/document-number-template"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "settings.systemSettings.documentNumberTemplates"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$store.getters["userProperties"].system_settings
                    .is_module_delegation_enabled === 2
                    ? _c(
                        "fieldset",
                        { staticClass: "custom-fieldset" },
                        [
                          _c("legend", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "settings.systemSettings.delegationFields"
                                )
                              )
                            )
                          ]),
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.transportSettlementTypes,
                              label: _vm.$t(
                                "settings.systemSettings.availableTransportSettlement"
                              ),
                              clearable: "",
                              "item-text": "text",
                              "item-value": "value",
                              multiple: ""
                            },
                            model: {
                              value: _vm.settings.allowed_transport_settlement,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "allowed_transport_settlement",
                                  $$v
                                )
                              },
                              expression:
                                "settings.allowed_transport_settlement"
                            }
                          }),
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.transportTypes,
                              label: _vm.$t(
                                "settings.systemSettings.availableTransportType"
                              ),
                              clearable: "",
                              "item-text": "name",
                              "item-value": "id",
                              multiple: ""
                            },
                            model: {
                              value: _vm.settings.allowed_transport_types,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "allowed_transport_types",
                                  $$v
                                )
                              },
                              expression: "settings.allowed_transport_types"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.requiredOptionalNotAvailable,
                              label: _vm.$t(
                                "settings.systemSettings.costCentreOnDelegation"
                              )
                            },
                            model: {
                              value: _vm.settings.cost_centre_on_delegations,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "cost_centre_on_delegations",
                                  $$v
                                )
                              },
                              expression: "settings.cost_centre_on_delegations"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.enableDisable,
                              label: _vm.$t(
                                "settings.systemSettings.delegationTask"
                              )
                            },
                            model: {
                              value: _vm.settings.is_delegation_task_enabled,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "is_delegation_task_enabled",
                                  $$v
                                )
                              },
                              expression: "settings.is_delegation_task_enabled"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.enableDisable,
                              label: _vm.$t(
                                "settings.systemSettings.reInvoicingOnExternalContractorModule"
                              )
                            },
                            model: {
                              value: _vm.settings.external_customers_module,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "external_customers_module",
                                  $$v
                                )
                              },
                              expression: "settings.external_customers_module"
                            }
                          }),
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.accommodationSettlementTypes,
                              label: _vm.$t(
                                "settings.systemSettings.availableAccommodationType"
                              ),
                              clearable: "",
                              "item-text": "text",
                              "item-value": "value",
                              multiple: ""
                            },
                            model: {
                              value:
                                _vm.settings.allowed_accommodation_settlement,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "allowed_accommodation_settlement",
                                  $$v
                                )
                              },
                              expression:
                                "settings.allowed_accommodation_settlement"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.requiredOptional,
                              label: _vm.$t(
                                "settings.systemSettings.transportAttachmentRequired"
                              )
                            },
                            model: {
                              value: _vm.settings.transport_attachment_required,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "transport_attachment_required",
                                  $$v
                                )
                              },
                              expression:
                                "settings.transport_attachment_required"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.requiredOptional,
                              label: _vm.$t(
                                "settings.systemSettings.accommodationAttachmentRequired"
                              )
                            },
                            model: {
                              value:
                                _vm.settings.accommodation_attachment_required,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "accommodation_attachment_required",
                                  $$v
                                )
                              },
                              expression:
                                "settings.accommodation_attachment_required"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.requiredOptional,
                              label: _vm.$t(
                                "settings.systemSettings.otherCostAccountNumberRequired"
                              )
                            },
                            model: {
                              value:
                                _vm.settings.other_cost_account_number_required,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "other_cost_account_number_required",
                                  $$v
                                )
                              },
                              expression:
                                "settings.other_cost_account_number_required"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.requiredOptional,
                              label: _vm.$t(
                                "settings.systemSettings.otherTransportCommentRequired"
                              )
                            },
                            model: {
                              value:
                                _vm.settings.other_transport_comment_required,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "other_transport_comment_required",
                                  $$v
                                )
                              },
                              expression:
                                "settings.other_transport_comment_required"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.requiredOptional,
                              label: _vm.$t(
                                "settings.systemSettings.transportAlreadySettledCommentRequired"
                              )
                            },
                            model: {
                              value:
                                _vm.settings
                                  .transport_already_settled_comment_required,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "transport_already_settled_comment_required",
                                  $$v
                                )
                              },
                              expression:
                                "settings.transport_already_settled_comment_required"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.requiredOptional,
                              label: _vm.$t(
                                "settings.systemSettings.accommodationAlreadySettledCommentRequired"
                              )
                            },
                            model: {
                              value:
                                _vm.settings
                                  .accommodation_already_settled_comment_required,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "accommodation_already_settled_comment_required",
                                  $$v
                                )
                              },
                              expression:
                                "settings.accommodation_already_settled_comment_required"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.verifyDistance,
                              label: _vm.$t(
                                "settings.systemSettings.distanceVerify"
                              )
                            },
                            model: {
                              value:
                                _vm.settings
                                  .delegation_google_distance_verification,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "delegation_google_distance_verification",
                                  $$v
                                )
                              },
                              expression:
                                "settings.delegation_google_distance_verification"
                            }
                          }),
                          _c("v-text-field", {
                            attrs: {
                              label:
                                _vm.$t(
                                  "settings.systemSettings.allowedDifferenceMapsApi"
                                ) + " [%]",
                              suffix: "%"
                            },
                            model: {
                              value:
                                _vm.settings
                                  .delegation_google_distance_verification_allowed_difference,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "delegation_google_distance_verification_allowed_difference",
                                  $$v
                                )
                              },
                              expression:
                                "settings.delegation_google_distance_verification_allowed_difference"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.delegationAdvanceFlowType,
                              label: _vm.$t(
                                "settings.systemSettings.delegationAdvanceFlowType"
                              )
                            },
                            model: {
                              value: _vm.settings.delegation_advance_flow,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "delegation_advance_flow",
                                  $$v
                                )
                              },
                              expression: "settings.delegation_advance_flow"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              items: _vm.allowDeny,
                              label: _vm.$t(
                                "settings.systemSettings.multipleAdvances"
                              )
                            },
                            model: {
                              value:
                                _vm.settings
                                  .is_allowed_multiple_delegation_advance,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings,
                                  "is_allowed_multiple_delegation_advance",
                                  $$v
                                )
                              },
                              expression:
                                "settings.is_allowed_multiple_delegation_advance"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-tab-item",
                { key: "delegation-order", staticClass: "mt-2" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.enableDisable,
                      label: _vm.$t(
                        "settings.systemSettings.isDelegationConfirmSignRequired"
                      )
                    },
                    model: {
                      value: _vm.settings.delegation_order_confirm_is_required,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.settings,
                          "delegation_order_confirm_is_required",
                          $$v
                        )
                      },
                      expression:
                        "settings.delegation_order_confirm_is_required"
                    }
                  }),
                  _c("v-select", {
                    attrs: {
                      items: _vm.delegationNumberSettingType,
                      label: _vm.$t(
                        "settings.systemSettings.delegationOrderNumberSettingType"
                      )
                    },
                    on: {
                      change: function(value) {
                        _vm.changeAfterConfirm(
                          value,
                          _vm.settings,
                          "delegation_order_number_setting_type"
                        )
                      }
                    },
                    model: {
                      value: _vm.contextDelegationOrderNumberSettingType,
                      callback: function($$v) {
                        _vm.contextDelegationOrderNumberSettingType = $$v
                      },
                      expression: "contextDelegationOrderNumberSettingType"
                    }
                  }),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-select",
                                _vm._g(
                                  {
                                    attrs: {
                                      items: _vm.delegationNumberDate,
                                      label: _vm.$t(
                                        "settings.systemSettings.delegationNumberDate"
                                      )
                                    },
                                    on: {
                                      change: function(value) {
                                        _vm.changeAfterConfirm(
                                          value,
                                          _vm.settings,
                                          "delegation_order_number_date"
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.contextDelegationOrderNumberDate,
                                      callback: function($$v) {
                                        _vm.contextDelegationOrderNumberDate = $$v
                                      },
                                      expression:
                                        "contextDelegationOrderNumberDate"
                                    }
                                  },
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "settings.systemSettings.changeThisSettingCanBlock"
                            )
                          ) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "v-select",
                    {
                      attrs: {
                        items: _vm.availableDelegationOrderNumberTemplates,
                        label: _vm.$t(
                          "settings.systemSettings.delegationNumberTemplate"
                        ),
                        rules: _vm.settings.validateDelegationOrderTemplate()
                      },
                      on: {
                        change: function(value) {
                          _vm.changeAfterConfirm(
                            value,
                            _vm.settings,
                            "delegation_order_number_template"
                          )
                        }
                      },
                      model: {
                        value: _vm.contextDelegationOrderNumberTemplate,
                        callback: function($$v) {
                          _vm.contextDelegationOrderNumberTemplate = $$v
                        },
                        expression: "contextDelegationOrderNumberTemplate"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          attrs: { slot: "append-outer" },
                          slot: "append-outer"
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                color: "accent",
                                to:
                                  "/settings/system-settings/document-number-template"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "settings.systemSettings.documentNumberTemplates"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c("v-divider", { staticClass: "my-3" }),
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("settings.systemSettings.settlementBasedOnOrder")
                      )
                    )
                  ]),
                  _c("v-select", {
                    attrs: {
                      items: _vm.allowDeny,
                      label: _vm.$t(
                        "settings.systemSettings.allowedDifferenceTransportType"
                      )
                    },
                    model: {
                      value:
                        _vm.settings.delegation_from_order_transport_change,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.settings,
                          "delegation_from_order_transport_change",
                          $$v
                        )
                      },
                      expression:
                        "settings.delegation_from_order_transport_change"
                    }
                  }),
                  _c("v-select", {
                    attrs: {
                      items: _vm.allowDeny,
                      label: _vm.$t(
                        "settings.systemSettings.allowedDifferenceCostCentre"
                      )
                    },
                    model: {
                      value:
                        _vm.settings.delegation_from_order_cost_centre_change,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.settings,
                          "delegation_from_order_cost_centre_change",
                          $$v
                        )
                      },
                      expression:
                        "settings.delegation_from_order_cost_centre_change"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-tab-item",
                { key: "API", staticClass: "mt-2" },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t(
                        "settings.systemSettings.googleMapsPlacesApiKey"
                      ),
                      placeholder: _vm.$t(
                        "settings.systemSettings.settingPredefinedKeys"
                      )
                    },
                    model: {
                      value: _vm.settings.google_maps_places_api_key,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.settings,
                          "google_maps_places_api_key",
                          $$v
                        )
                      },
                      expression: "settings.google_maps_places_api_key"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t(
                        "settings.systemSettings.googleMapsGeocodingApiKey"
                      ),
                      placeholder: _vm.$t(
                        "settings.systemSettings.settingPredefinedKeys"
                      )
                    },
                    model: {
                      value: _vm.settings.google_maps_api_geocoding_api_key,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.settings,
                          "google_maps_api_geocoding_api_key",
                          $$v
                        )
                      },
                      expression: "settings.google_maps_api_geocoding_api_key"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t(
                        "settings.systemSettings.googleMapsDistanceMatrixApiKey"
                      ),
                      placeholder: _vm.$t(
                        "settings.systemSettings.settingPredefinedKeys"
                      )
                    },
                    model: {
                      value: _vm.settings.google_maps_distance_matrix_api_key,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.settings,
                          "google_maps_distance_matrix_api_key",
                          $$v
                        )
                      },
                      expression: "settings.google_maps_distance_matrix_api_key"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-tab-item",
                { key: "IP", staticClass: "mt-2", attrs: { eager: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: _vm.$t(
                        "settings.systemSettings.accessFromNonBlockedIp"
                      ),
                      items: _vm.allowDeny
                    },
                    model: {
                      value: _vm.settings.access_from_non_blocked_ip,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.settings,
                          "access_from_non_blocked_ip",
                          $$v
                        )
                      },
                      expression: "settings.access_from_non_blocked_ip"
                    }
                  }),
                  _c("v-combobox", {
                    ref: "whitelist",
                    attrs: { label: "Whitelist", multiple: "", chips: "" },
                    model: {
                      value: _vm.settings.ip_whitelist,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "ip_whitelist", $$v)
                      },
                      expression: "settings.ip_whitelist"
                    }
                  }),
                  _c("v-combobox", {
                    ref: "blacklist",
                    attrs: { label: "BlackList", multiple: "", chips: "" },
                    model: {
                      value: _vm.settings.ip_blacklist,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "ip_blacklist", $$v)
                      },
                      expression: "settings.ip_blacklist"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "v-btn",
            {
              attrs: {
                disabled: !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                block: "",
                color: "accent"
              },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("global.save")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }